module.exports = __webpack_public_path__ + "img/circle-4.46da540.png";